const listColumn = {
  TICKER: 'ticker',
  VOLUME: 'volume',
  PRICE: 'price',
  PERCENT_PRICE_CHANGE: 'percentPriceChange',
  OLD_LOW: 'oldLow',
  RTD11: 'financial.rtd11',
  PE: 'financial.rtd21',
  PB: 'financial.rtd25',
  BETA: 'financial.rtd19',
  RANKING: 'rank',
  TOTAL_RANK: 'totalRank',
  HIGH_PRICE: 'ceilingPrice',
  LOW_PRICE: 'floorPrice',
  REF_PRICE: 'referencePrice',
  CHANGE_PRICE: 'priceChange',
};

const listHideColumn = [
  'financial.rtd11',
  'ceilingPrice',
  'floorPrice',
  'referencePrice',
  'priceChange',
  'totalRank',
];

export default {
  listColumn,
  listHideColumn,
};
